import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'

import {
  SustainableFitchSiteHeader,
  SustainableFitchSiteHeaderLinkProps
} from 'suf_storybook'

const query = graphql`
  query SiteHeaderQuery {
    contentfulTopNavigation(label: { eq: "SF Header Menu" }) {
      label
      navigation {
        label
        title
        text {
          text
        }
        menus {
          label
          title
          relatedLinkHref: href
          links {
            ... on ContentfulRelatedLinks {
              label
              title
              relatedLinkHref: href
              links {
                ... on ContentfulRelatedLinks {
                  label
                  title
                  relatedLinkHref: href
                }
              }
            }
          }
        }
      }
    }
  }
`

const RenderLink = ({
  className,
  label,
  slug
}: SustainableFitchSiteHeaderLinkProps) => (
  <Link className={className} to={slug}>
    {label}
  </Link>
)

export type Props = {
  hasLanguageToggle?: boolean
  toggleLanguage: (selectedLang: string) => void
  toggleOverlayClick: () => void
  languageSlug?: string
  isOverlayOpen: boolean
  closeOverlay: () => void
}

const defaultToggle = (languageSelected: string) => languageSelected

const parseSiteHeaderProps = ({
  hasLanguageToggle,
  isOverlayOpen,
  toggleLanguage,
  toggleOverlayClick,
  languageSlug,
  closeOverlay
}: Props) => {
  const showLanguageToggle = hasLanguageToggle || false
  const toggleLanguageAvailable = toggleLanguage || defaultToggle
  const loginLink = process.env.CLIENT_LOGIN_LINK
    ? process.env.CLIENT_LOGIN_LINK
    : ''

  return {
    hasLanguageToggle: showLanguageToggle,
    toggleLanguage: toggleLanguageAvailable,
    toggleOverlayClick,
    languageSlug,
    isOverlayOpen,
    closeOverlay,
    loginLink
  }
}

export default (props: Props) => {
  const data = useStaticQuery(query)
  return (
    <SustainableFitchSiteHeader
      renderLink={RenderLink}
      {...data.contentfulTopNavigation}
      {...parseSiteHeaderProps(props)}
    />
  )
}
